import { createContext } from "react";

import { MuxSpecificationListingItem } from "../listing/MuxSpecificationListingItem";
import { MuxSpecificationListingFilters } from "../listing/useMuxSpecificationListingFilters";

interface IMuxSpecificationListingContext {
    allItems: MuxSpecificationListingItem[];
    items: MuxSpecificationListingItem[];
    isLoading: boolean;
    totalItems: number;
    add(item: MuxSpecificationListingItem): void;
    update(item: MuxSpecificationListingItem): void;
    load(filters: MuxSpecificationListingFilters): void;
}

export const MuxSpecificationListingContext = createContext<IMuxSpecificationListingContext>(
    {} as IMuxSpecificationListingContext
);
